import {createCookieUI, CookieUI} from './cookieUI';

export class Cookie {
  public constructor(private ui: CookieUI) {
    this.ui.checkReferrer(this.createCookie.bind(this))
      if (this.ui.isNewsletterReferer() === true) {
        this.ui.createNewsletterCookie();
      }
    this.ui.saveParameter();
  }

  public createCookie() {
    this.ui.setTrackingCookie();
    this.ui.isNewsletterReferer();
  }
}

export function initCookie() : Cookie[]{
  const uiInstance = createCookieUI();
  return uiInstance.map((uiInstance: CookieUI) => {
    return new Cookie(uiInstance);
  });
}